<div class="min-h-[80vh] w-full">
  <div class="w-full bg-[#001847] h-[370px] relative" id="mask-image">
    <div class="container">
      <div class="w-full text-center relative  float-end mt-5 h-[360px]">
        <h1 class="text-white fw-medium fs-3 m-0 pb-2 mb-1   mt-5">ایران هتل
        </h1>
        <h2 class="text-white fs-1.6">قوانین و مقررات رزرو اینترنتی</h2>
        <img src="/assets/images/header-bg.svg" width="500" height="250" alt="image"
          class="full-img d-block absolute left-0 bottom-0" fetchpriority="high">
      </div>
      <div class="w-full float-start mt-10">
        <nav>
          <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
            <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
              *ngFor="let bread of listBreadcrumb; let last = last; let index = index;let first = first">
              <ng-container *ngIf="!last">
                <a [href]="first ? '/' : bread['@id']"
                >
                  {{ bread.name }}
                </a>
              </ng-container>
              <ng-container *ngIf="last">
                <span class=""> {{ bread.name }} </span>
              </ng-container>
        
            </li>
          </ol>
        </nav>
        
        <h4 class="font-bold mt-5">صحت و سقم اطلاعات درج شده هتل ها در شبكه ايران هتل آنلاين ( با نام اختصاري آي هو )
        </h4>
        <p class="text-muted text-[14px] !font-extralight leading-8 my-3">
  
          كاربر گرامي از انجا كه كليه اطلاعات و مشخصاتي كه از هتل و هتل آپارتمانها اعم از : نرخ نامه، روش محاسبه عوارض، حق
          سرويس،
          وجود صبحانه، براي اتاق ها، استخر و سونا، ترانسفر از فرودگاه و راه آهن و كليه امكانات و تجهيزاتي كه بر روي سايت
          آي هو
          قرار دارد، عينا از فرم اطلاعات خواسته شده از هتل مربوط مي باشد و شبكه عينا مطالب را در سايت نمايش داده است، كليه
          مسئوليت
          هاي مربوط به اطلاعات بر عهده هتل مورد نظر مي باشد.
  
          شما كاربر گرامي در صورت ايجاد كوچكترين شك و ترديد در خصوص اطلاعات ذكر شده، بر روي شبكه مي توانيد، قبل از اقدام
          به رزرو
          هتل مربوطه، اقدام به بررسي صحت و سقم اطلاعات مربوطه نماييد. و از انجا كه بر اساس سياست كاري شبكه هيچ اطلاعات
          تماسي از
          هتل هاي عضو شبكه بر روي سايت قرار نمي گيرد،شما مي توانيد از درگاههاي ديگر اطلاعاتي، اقدام به پيدا نمودن شماره
          هاي تماس
          هتل مورد نظرتان نماييد.
        </p>
      </div>
    </div>
  </div>

</div>
